import { Location__Service } from '@graphql/platform';

export const SERVICE_TO_ENUM = {
  storage: Location__Service.SmartStorage,
  moving: Location__Service.Moving,
};
